import React from 'react';
import './LanguageSwitcher.css';
import { useI18n } from '../../i18n/I18nProvider';
import { SUPPORTED_LANGS } from '../../i18n/languages';
import i18n from '../../i18n';

export default function LanguageSwitcher({ compact = true, showLabel = true }) {
  const { lang, setLang, t } = useI18n();

  const handleLanguageChange = (e) => {
    const code = e.target.value;

    setLang(code);                 // local state
    i18n.changeLanguage(code);     // i18next
    localStorage.setItem('i18nextLng', code); // persist
  };

  return (
    <div className={`bf-lang-switcher ${compact ? 'compact' : ''}`}>
      {showLabel && (
        <div className="bf-lang-title">
          {t('language.select_label') || 'Language'}
        </div>
      )}

      <div className="bf-lang-select-wrap">
        <select
          className="bf-lang-select"
          value={lang}
          onChange={handleLanguageChange}
          aria-label="Select language"
        >
          {SUPPORTED_LANGS.map((l) => (
            <option key={l.code} value={l.code}>
              {l.label}
            </option>
          ))}
        </select>

        <span className="bf-lang-select-caret" aria-hidden>
          ▾
        </span>
      </div>
    </div>
  );
}
